import React, { useEffect, useState } from "react";
import { Typewriter } from "react-simple-typewriter";

const ReviewCard = ({
  name,
  role,
  text,
  image,
  onInteractStart,
  onInteractEnd,
}) => (
  <div
    className="review-card upgraded"
    onMouseEnter={onInteractStart}
    onMouseLeave={onInteractEnd}
    onTouchStart={onInteractStart}
    onTouchEnd={onInteractEnd}
  >
    <img
      src={`https://ethiccraft.org/${image}`}
      alt={name}
      className="avatar"
    />
    <div className="review-content">
      <h4>{name}</h4>
      <p className="role">{role}</p>
      <p className="text">“{text}”</p>
    </div>
  </div>
);

const ReviewsSection = () => {
  const [reviewsTop, setReviewsTop] = useState([]);
  const [reviewsBottom, setReviewsBottom] = useState([]);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await fetch(
          "https://ethiccraft.org/backend/camp_reviews/read_isShown.php",
        );
        const data = await res.json();

        const top = data.filter((r) => r.position === "top");
        const bottom = data.filter((r) => r.position === "bottom");

        setReviewsTop(top);
        setReviewsBottom(bottom);
      } catch (err) {
        console.error("Failed to fetch reviews:", err);
      }
    };

    fetchReviews();
  }, []);

  const handlePause = () => setIsPaused(true);
  const handleResume = () => setIsPaused(false);

  return (
    <div className="reviews-section">
      <h2 className="reviews-title typing">
        <Typewriter
          words={[
            "✨ Hear from our Happy Travelers ✨",
            "🧳 Their Adventures, Your Next Destination 🧳",
            "🌍 See the World Through Their Eyes 🌍",
            "✨ Real Stories from Unforgettable Journeys ✨",
          ]}
          loop={0}
          cursor
          cursorStyle="|"
          typeSpeed={70}
          deleteSpeed={50}
          delaySpeed={1500}
        />
      </h2>

      <div className="reviews-row-wrapper">
        <div className={`reviews-row slide-left ${isPaused ? "paused" : ""}`}>
          {reviewsTop.concat(reviewsTop).map((review, index) => (
            <ReviewCard
              key={`top-${index}`}
              {...review}
              onInteractStart={handlePause}
              onInteractEnd={handleResume}
            />
          ))}
        </div>
      </div>

      <div className="reviews-row-wrapper">
        <div className={`reviews-row slide-right ${isPaused ? "paused" : ""}`}>
          {reviewsBottom.concat(reviewsBottom).map((review, index) => (
            <ReviewCard
              key={`bottom-${index}`}
              {...review}
              onInteractStart={handlePause}
              onInteractEnd={handleResume}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewsSection;
